import React from "react";
import {
  RATING_DEFAULT_VALUES,
  PERCENTAGE_FORMAT_CONSTANTS,
  customerInsightsConstants,
} from "../../../constants";

const {
  SURVEY_SENT,
  RESPONSE_RATE,
  PASSIVE_RATING,
  POSITIVE_RATING,
  SURVEY_COMPLETED,
  AVERAGE_SENTIMENT_RATING,
  AVERAGE_TEANSACTION_RATING,
} = customerInsightsConstants;

const { DECIMAL_PLACES, MULTIPLIER } = PERCENTAGE_FORMAT_CONSTANTS;

const CustomerInsightComponent = ({ customerInsights }) => {
  const calculateResponseRate = (surveySent, surveyFilled) => {
    if (!surveySent) {
      return RATING_DEFAULT_VALUES.ZERO_CHANGE;
    }
    return ((surveyFilled / surveySent) * MULTIPLIER).toFixed(DECIMAL_PLACES);
  };

  const customerInsightsDetials = [
    { id: 1, name: SURVEY_SENT, value: customerInsights?.ordersPlaced },
    { id: 2, name: SURVEY_COMPLETED, value: customerInsights?.surveyFilled },
    {
      id: 3,
      name: RESPONSE_RATE,
      value: `${calculateResponseRate(
        customerInsights?.ordersPlaced,
        customerInsights?.surveyFilled,
      )}%`,
    },
  ];

  const customerInsightsRating = [
    {
      id: 1,
      name: AVERAGE_TEANSACTION_RATING,
      value: customerInsights?.averageTranactionRating,
    },
    {
      id: 2,
      name: AVERAGE_SENTIMENT_RATING,
      value: customerInsights?.averageSentimentRating,
    },
  ];

  const getRatingClass = (value) => {
    if (value >= POSITIVE_RATING) {
      return "text-success";
    }
    if (value >= PASSIVE_RATING) {
      return "text-warning";
    }
    return "text-danger";
  };

  return (
    <div>
      {customerInsightsDetials.map((val) => (
        <p key={val.id}>
          <strong className="opacity-50">{val.name}: </strong>
          <span className="text-black fw-bold">{val.value}</span>
        </p>
      ))}
      {customerInsightsRating.map((val) => (
        <p key={val.id}>
          <strong className="opacity-50">{val.name}: </strong>
          <span className={`fw-bold ${getRatingClass(val.value)}`}>
            {val.value}
          </span>
        </p>
      ))}
    </div>
  );
};

export default React.memo(CustomerInsightComponent);
